export enum UserAccountEnum {
    Freelancer = 0,
    Employee = 1,
}

export enum UserGroupType {
    Single = 0,
    Company = 1
}